<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: {
    type: String,
    required: true,
    validator: value => ['text', 'image'].includes(value),
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const selectType = type => {
  emit('update:modelValue', type);
};
</script>

<template>
  <div class="flex flex-col gap-1.5">
    <span class="text-sm font-medium text-n-slate-12">
      {{ t('CANNED_MGMT.FORM.TYPE.LABEL') }}
    </span>
    <div
      class="inline-flex p-1 rounded-lg border gap-1 w-fit border-n-weak bg-n-alpha-2"
      role="group"
    >
      <button
        type="button"
        class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
        :class="
          modelValue === 'text'
            ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
            : 'text-n-slate-11 hover:text-n-slate-12'
        "
        @click="selectType('text')"
      >
        {{ t('CANNED_MGMT.FORM.TYPE.TEXT') }}
      </button>
      <button
        type="button"
        class="px-3 py-1.5 text-sm font-medium rounded-md transition-colors"
        :class="
          modelValue === 'image'
            ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
            : 'text-n-slate-11 hover:text-n-slate-12'
        "
        @click="selectType('image')"
      >
        {{ t('CANNED_MGMT.FORM.TYPE.IMAGE') }}
      </button>
    </div>
    <p class="text-xs text-n-slate-11">
      {{ t('CANNED_MGMT.FORM.TYPE.HELP') }}
    </p>
  </div>
</template>
